import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-registro-exitoso',
  templateUrl: './registro-exitoso.component.html',
  styleUrls: ['./registro-exitoso.component.css']
})
export class RegistroExitosoComponent implements OnInit {

  // Mensaje que se mostrará en el template
  mensaje: string = 'Tu cuenta se ha registrado correctamente, se agregaran datos necesarios. Redirigiendo al login...';

  constructor(private router: Router, private authService: AuthService) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.authService.logout();
    }, 5000);
  }
}
